import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { changeLocation } from '../../api/Location';

import { Loader } from 'react-loaders';

import Navigation from '../components/grading/components/navigation';
import Pagination from '../components/grading/components/pagination';

import OverallScore from '../components/grading/pages/overall-score';
import TeamScore from '../components/grading/pages/team-score';
// Peer Score / Feedback Submission / Engagement Score pages are
// no longer mounted in the grading nav. The component files remain
// on disk for reference but are not imported here.

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  background: #f5f6f7;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 80%;
  max-width: 1040px;
  @media (max-width: 1630px) {
    width: 100%;
  }
`;

class InstructorGrading extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      currentCategory: 0,
      currentStep: 0,
      navigation: [],
      loaded: false,
      round: {},
      roundId: 0
    };
  }

  componentWillMount() {
    const { rounds } = this.props;
    const activeRound = this.activeRound;
    const round = rounds.find(i => Number(i.number) === Number(activeRound));

    const roundId = round ? round.id : 0;
    this.setState({
      round,
      roundId
    });
  }

  componentDidMount() {
    this.loadNavigation(() => {
      this.updateCurrentState();
    });
  }

  get activeRound() {
    const { currentRound, roundInUrl } = this.props;

    return Number(roundInUrl || currentRound);
  }

  loadNavigation(callback) {

    // Trimmed to 2 sections. Round Targets is now the landing page
    // (was 'Team Score'). Scoring Weights consolidates both round
    // weights (formerly under Team Score) and activity score weights
    // (formerly Overall Score).
    const navigation = [
      {
        title: 'Round Targets',
        pattern: '/instructor/grading/team-score',
        steps: [
          {
            url: '/instructor/grading/team-score',
            component: TeamScore,
          }
        ]
      },
      {
        title: 'Scoring Weights',
        pattern: '/instructor/grading/overall-score',
        steps: [
          {
            url: '/instructor/grading/overall-score',
            component: OverallScore,
          },
        ]
      },
    ];

    if (JSON.stringify(navigation) !== JSON.stringify(this.state.navigation)) {
      this.setState({
        navigation,
      }, () => {
        if (callback) {
          callback();
        }
      });
    } else {
      if (callback) {
        callback();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.updateCurrentState();
    }
  }

  updateCurrentState = () => {
    const { navigation } = this.state;

    let currentCategory = 0;
    let currentStep = 0;
    for (let i = 0; i < navigation.length; i++) {
      const stepIndex = navigation[i].steps.findIndex(j => j.url === this.props.location.pathname);
      if (stepIndex > -1) {
        currentCategory = i;
        currentStep = stepIndex;
        break;
      }
    }

    if (
      currentCategory !== this.state.currentCategory
      || currentStep !== this.state.currentStep
    ) {

      this.setState({
        currentCategory,
        currentStep,
      }, () => {
        this.checkLocation();
      });
    } else {
      if (this.props.location.pathname === '/grading') {
        this.checkLocation();
      }
    }
    this.setState({
      loaded: true
    });
  }

  checkLocation = () => {
    const { currentCategory, currentStep, navigation } = this.state;
    const activeRound = this.activeRound;

    if (this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url) {
      changeLocation(`${navigation[currentCategory].steps[currentStep].url}?round=${activeRound}`);
    }
  }

  goNext = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let nextCategory = currentCategory;
    let nextStep = currentStep + 1;
    if (nextStep >= navigation[currentCategory].steps.length) {
      nextCategory = currentCategory + 1;
      nextStep = 0;

      if (nextCategory >= navigation.length) {
        return false;
      } else if (nextStep >= navigation[nextCategory].steps.length) {
        nextCategory = currentCategory + 2;
        nextStep = 0;

        if (nextCategory >= navigation.length) {
          return false;
        }
      }
    }

    this.setState({
      currentCategory: nextCategory,
      currentStep: nextStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  goPrev = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let prevCategory = currentCategory;
    let prevStep = currentStep - 1;
    if (prevStep < 0) {
      prevCategory = currentCategory - 1;
      if (prevCategory < 0) {
        return false;
      }

      prevStep = navigation[prevCategory].steps.length - 1;
      if (prevStep < 0) {
        prevCategory = currentCategory - 2;
        if (prevCategory < 0) {
          return false;
        }

        prevStep = navigation[prevCategory].steps.length - 1;
      }
    }

    this.setState({
      currentCategory: prevCategory,
      currentStep: prevStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  get isFirstStep() {
    const { currentCategory, currentStep } = this.state;

    return currentCategory === 0 && currentStep === 0;
  }

  get isLastStep() {
    const { currentCategory, currentStep, navigation } = this.state;

    const lastCategory = navigation.length - 1;
    const lastStep = navigation[lastCategory].steps.length - 1;

    return currentCategory === lastCategory && currentStep === lastStep;
  }

  get countOfSteps() {
    const { currentCategory, navigation } = this.state;

    return navigation[currentCategory].steps.length;
  }

  render() {
    const {
      currentCategory,
      currentStep,
      navigation,
      loaded,
      roundId,
    } = this.state;
    const { rounds } = this.props;
    const activeRound = this.activeRound;

    if (navigation.length === 0 || !loaded) {
      return (
        <Wrapper>
          <Loader type="ball-scale-ripple" active />
        </Wrapper>
      );
    }

    const category = navigation[currentCategory];
    let Component = null;
    if (category) {
      Component = category.steps[currentStep].component;
    }

    return (
      <Wrapper>
        <Navigation
          data={navigation}
          category={currentCategory}
          activeRound={activeRound}
        />
        <Content>
          <ContentWrapper>
            {Component && (
              <Component
                activeRound={activeRound}
                rounds={rounds}
                roundId={roundId}
              />
            )}
          </ContentWrapper>
          <Pagination
            goNext={this.goNext}
            goPrev={this.goPrev}
            isFirstStep={this.isFirstStep}
            isLastStep={this.isLastStep}
            currentStep={currentStep + 1}
            countOfSteps={this.countOfSteps}
          />
        </Content>
      </Wrapper>
    );
  }

}

export default InstructorGrading;



// WEBPACK FOOTER //
// ./src/instructor/containers/grading.js